<template>
  <ion-button router-link="/cart">
    <ion-icon slot="icon-only" :icon="cart"></ion-icon>
    <ion-badge v-if="numOfCartItems > 0" id="notifications-badge" color="danger">{{ numOfCartItems }}</ion-badge>
  </ion-button>
</template>

<script lang="ts">
// icons
import { cart } from 'ionicons/icons';

// components
import { IonButton, IonIcon, IonBadge, IonLabel, } from '@ionic/vue';

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { computed } from 'vue';

export default {
  components: { IonButton, IonIcon, IonBadge, IonLabel, },
  setup() {
    const store = useStore();
    const { t } = useI18n();
    const numOfCartItems = computed(() => store.getters.numOfCartItems);

    // 3. return variables & methods to be used in template HTML
    return {
      t,

      // icons
      cart,

      // variables
      numOfCartItems
    }
  }
}
</script>

<style scoped>
  #notifications-badge {
    position: absolute;
    top: 0;
    border-radius: 100%;
    padding: 3px 2px 2px;
    font-size: 8px;
  }
</style>